import script from "./business.vue?vue&type=script&setup=true&lang=js"
export * from "./business.vue?vue&type=script&setup=true&lang=js"

import "./business.vue?vue&type=style&index=0&id=a0cf41d8&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0cf41d8"]])

export default __exports__